import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-content-header-edit',
  imports: [CommonModule, ButtonModule],
  templateUrl: './content-header-edit.component.html',
  styleUrl: './content-header-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentHeaderEditComponent {
  title = input.required<string>();
  id = input.required<string | undefined>();
  isViewOnly = input.required<boolean>();
  hasPermissionEdit = input.required<boolean>();
  invalid = input.required<boolean>();
  instance = input<any>();
  cancel = output();
  save = output();
  toggleEdit = output();
  hideSaveButton = input<boolean>();
  hideViewOnlyButton = input<boolean>();
}
